// extracted by mini-css-extract-plugin
export default {"container":"uhbe+","name":"qIBZ9"};